import React from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

import { useMomentumBarSlotVisible } from '../../hooks/useMomentumBarSlotVisible';
import { MomentumBar } from '../MomentumBar';
import { MomentumBarScrollPastTracker } from '../MomentumBarScrollPastTracker';

type Props = Readonly<{
	petitionId: string;
}>;

export const MomentumBarExperimentContent: React.FC<Props> = ({ petitionId }) => {
	const {
		data: {
			petition: { supporterCommentsConnection },
			mediaSourcesPage,
		},
	} = usePetitionDetailsPageData();
	const momentumBarSlotVisible = useMomentumBarSlotVisible();

	const commentsCount = supporterCommentsConnection.totalCount || 0;
	const hasMediaMentions = mediaSourcesPage.numberOfMediaSources > 0;

	if (commentsCount === 0) {
		return null;
	}

	return (
		<>
			<MomentumBar shouldFetchShareCounts={!hasMediaMentions} />
			{momentumBarSlotVisible && <MomentumBarScrollPastTracker petitionId={petitionId} />}
		</>
	);
};
